(ns ycweb.app.blitz.packing.packer.waitingroom
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.app.blitz.packing.common :as pack-cmn]))

(rum/defc waiting-room < rum/reactive [app-atom]
  [:div.section
   [:h2.u-text-center
    {:class (u/bem :heading [:standard])}
    "Waiting for Order"
    [:span.heading
     {:style {:margin-top "15px"}}
     [:div "We value your packing, please hold."]
     [:div "POS sessions may be recorded for quality assurances."]]]])

(rum/defc display-order < rum/reactive [runner-order]
  [:div
   [:div.section
    [:h2.u-text-center
     {:class (u/bem :heading [:standard])}
     (str "Next Order to Pack")]
    [:div.slats (pack-cmn/order-slat runner-order {})]]])

(rum/defc manual-order < rum/reactive [app-atom]
  [:div.section
   [:h2.u-text-center
    {:class (u/bem :heading [:standard])}
    "Fetch next order"
    ;;When Packer running is live, "Or wait for your next order"
    ;;Could even add in estimated wait time, take average of the last 10 orders.
    ;;Time taken between pack lane and pack desk
    [:span.heading
     {:style {:margin-top "15px"}}
     [:div "There are no orders in your queue"]
     [:div "Fetch your next order to pack."]]]])

(defn order-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Refresh"
       :action :packing/next-queued-order}

      {:label "Show Queued Orders"
       :action :packing/show-queued-orders}

      (when
       (or
         (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
         (cmn/has-permission? app-atom "SiteAdmin:Blitz:Packing:ViewAllOrders"))
        {:label "Show All Orders"
         :action :packing/show-all-orders})

      {:label "Cancel"
       :action :packing/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc landing-screen < rum/reactive [app-atom steps]
  (let [packing-atom (rum/cursor app-atom :packing)
        manual-fetch? (cmn/curact packing-atom :manual-fetch?)
        runner-order (cmn/curact packing-atom :runner-order)]
    (w/wrapper app-atom "Packing" {:modal-fn order-modal :steps steps :step :waiting-room}
      [(cond
         manual-fetch?
         (manual-order app-atom)

         runner-order
         (display-order runner-order)

         :else
         (waiting-room app-atom))]
      []
      (grid/pos-call-to-action
        {:left-fn
         #(grid/dispatch-action app-atom :packing/transition-prev
            {:screen :packing/printer-scan
             :status :packing-desk.status/paused})
         :right-plain true
         :right-text
         (cond
           manual-fetch? "Fetch Next"
           runner-order "Next")
         :right-fn
         (cond
           manual-fetch?
           #(grid/dispatch-action app-atom :packing/fetch-next-order {})

           runner-order
           #(do
              (swap! packing-atom assoc :order runner-order)
              (grid/dispatch-action app-atom :packing/start-packing-session {:order runner-order})))}))))

(defmethod grid/action :packing/fetch-next-order [app-atom _ _]
  (let [packing-atom (rum/cursor app-atom :packing)
        packing-area (cmn/curact packing-atom :area)
        packdesk (cmn/curact packing-atom :packdesk)]
    (toaster/open-subtle-progress app-atom)
    (comms/send :packing/fetch-next-order
      {:packdesk-uuid (:ent/uuid packdesk)
       :packing-area packing-area})))

(defmethod comms/receive :packing/fetch-next-order [app-atom {:keys [claimed-order]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:packing :order] claimed-order)
  (t/transition-next app-atom :packing/scan-shelf))

(defmethod grid/action :packing/show-queued-orders [app-atom _ _]
  (let [packdesk (cmn/curact app-atom [:packing :packdesk])]
    (toaster/open-subtle-progress app-atom)
    (comms/send :packing/list-queued-orders
      {:packdesk-uuid (:ent/uuid packdesk)})))

(defmethod comms/receive :packing/list-queued-orders [app-atom {:keys [queued-orders]}]
  (let [packing-atom (rum/cursor app-atom :packing)]
    (toaster/close-subtle-progress app-atom)
    (swap! packing-atom assoc :queued-orders queued-orders)
    (grid/open-modal app-atom :packing/modal-order-list {:list-type :queued-orders})))

(defmethod grid/action :packing/show-all-orders [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :packing/packing-orders {}))

(defmethod grid/action :packing/refresh-queued-order [app-atom _ _]
  (let [packing-atom (rum/cursor app-atom :packing)
        packdesk (cmn/curact packing-atom :packdesk)]
    (toaster/open-subtle-progress app-atom)
    (swap! packing-atom dissoc :runner-order)
    (grid/close-modal app-atom)
    (comms/send :packing/next-queued-order
      {:quickship? false
       :packdesk-uuid (:ent/uuid packdesk)})))

;; ================== Modal: Order Lists

(rum/defc queued-list-body < rum/reactive [app-atom]
  (let [orders (cmn/curact app-atom [:packing :queued-orders])]
    [[:div.section
      [:div.u-margin-top-24
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "Your queued orders"]]]
     [[:div.slats
       (map
         (fn [i]
           (rum/with-key
             (pack-cmn/order-slat i {})
             (:id i)))
         orders)]]]))

(rum/defc order-list-body < rum/reactive [app-atom]
  (let [orders (cmn/curact app-atom [:packing :orders])]
    [[:div.section
      [:div.u-margin-top-24
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "All orders"]]]
     [[:div.slats
       (map
         (fn [i]
           (rum/with-key
             (pack-cmn/order-slat i
               {:on-click
                (cond
                  (and
                    (:packer i)
                    (not (:claim-owner? i)))
                  #(grid/dispatch-action app-atom :packing/claimed-order {:order i})

                  :else
                  #(grid/dispatch-action app-atom :packing/claim-order {:order i}))})
             (:id i)))
         orders)]]]))

(defmethod grid/modal-config :packing/modal-order-list [app-atom _ _]
  (let [{:keys [list-type]} (cmn/curact (grid/modal-cursor app-atom) :config)]
    (u/maybe assoc
      {:footer grid/list-modal-footer
       :modal-type :details
       :content-type :fill}
      :body
      (cond
        (= list-type :queued-orders)
        queued-list-body

        (= list-type :all-orders)
        order-list-body))))

(defmethod grid/action :packing/claimed-order [app-atom {:keys [order]} _]
  (grid/confirm-modal app-atom
    {:title (str "Order already claimed by: " (get-in order [:packer :firstname]))
     :text (str "Do you want to override the claim for this order? (" (:orderno order) ")")
     :confirm-text "Override claim"
     :confirm-key :packing/claim-order
     :confirm-data
     {:order order
      :override? true}
     :cancel-text "Cancel"
     :cancel-key :packing/close-modal}))

(defmethod grid/modal-config :packing/modal-claimed-order [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

;; ================== Request Claim on an Order
(defmethod comms/receive :packing/claim-order [app-atom {:keys [order]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:packing :order] order)
  (t/transition-next app-atom :packing/scan-shelf))

(defmethod grid/action :packing/claim-order [app-atom {:keys [order]} _]
  (toaster/open-subtle-progress app-atom)
  (let [packing-atom (rum/cursor app-atom :packing)
        packdesk-atom (rum/cursor packing-atom :packdesk)]
    (grid/close-modal app-atom)
    (swap! app-atom update :packing dissoc :scanned-shelves)
    (comms/send :packing/claim-order
      {:packdesk-uuid (:ent/uuid @packdesk-atom)
       :picking-order-uuid (:po-uuid order)})))